export const BASE_URL = "/mock-api";
export const USER_URL = `${BASE_URL}/users`;
export const AUTH_URL = `${BASE_URL}/auth`;
export const COMMENT_URL = `${BASE_URL}/comments`;
export const POST_URL = `${BASE_URL}/posts`;
